import { h, FunctionalComponent } from 'preact';

type ImageButtonProps = {
	image : string;
	label : string;
	active : boolean;
	onButtonClick : h.JSX.MouseEventHandler<HTMLButtonElement>;
}


const ImageButton : FunctionalComponent<ImageButtonProps> = ( props ) => {
	return (
		<button onClick={props.onButtonClick} style={{
			background   : 'none',
			border       : 'none',
			cursor       : 'pointer',
			width        : 'auto',
			height       : '100%',
			marginBottom : 0
		}}>
			<img src={props.image} alt={props.label} style={{ width : 'auto', height : '100%', marginBottom : 0 }} />
		</button>
	);
};

export default ImageButton;
